import styled, { css } from 'styled-components';
import Tippy from '@tippyjs/react';
import IconButton from '../IconButton';
import Button from '../Button';
import Divider from '../Divider';
import Icon from '../Icon';
import Chip from '../Chip';
import { prefix } from '../../tools/settings';
export var StyledMenu = styled(Tippy).withConfig({
  displayName: "Menustyles__StyledMenu",
  componentId: "sc-1e9kz8s-0"
})(["position:relative;background:var(--dentsu-color-white);box-shadow:var(--dentsu-shadow-12);outline:0;width:100%;&[data-animation='fade'][data-state='hidden']{opacity:0;}.tippy-arrow{&:before{content:'';position:absolute;border-color:transparent;border-style:solid;}&:after{content:'';position:absolute;z-index:-1;border-color:transparent;border-style:solid;}}&[data-placement^='bottom']{border-top:1px solid var(--dentsu-color-fuchsia);> .tippy-arrow{top:0;}> .tippy-arrow:before{border-bottom-color:var(--dentsu-color-white);top:-7px;left:-8px;border-width:0 8px 8px;transform-origin:center bottom;}> .tippy-arrow:after{border-bottom-color:var(--dentsu-color-fuchsia);border-width:0 7px 7px;left:-7px;top:-8px;}}&[data-placement^='top']{border-bottom:1px solid var(--dentsu-color-fuchsia);> .tippy-arrow{bottom:0;}> .tippy-arrow:before{border-top-color:var(--dentsu-color-white);bottom:-7px;left:-8px;border-width:8px 8px 0;transform-origin:center bottom;}> .tippy-arrow:after{border-top-color:var(--dentsu-color-fuchsia);border-width:7px 7px 0;left:-7px;bottom:-8px;}}&[data-placement^='right']{border-left:1px solid var(--dentsu-color-fuchsia);> .tippy-arrow{left:0;}> .tippy-arrow:before{border-right-color:var(--dentsu-color-white);bottom:-8px;left:-7px;border-width:8px 8px 8px 0;transform-origin:center bottom;}> .tippy-arrow:after{border-right-color:var(--dentsu-color-fuchsia);border-width:7px 7px 7px 0;left:-8px;bottom:-7px;}}&[data-placement^='left']{border-right:1px solid var(--dentsu-color-fuchsia);> .tippy-arrow{right:0;}> .tippy-arrow:before{border-left-color:var(--dentsu-color-white);bottom:-8px;right:-7px;border-width:8px 0 8px 8px;transform-origin:center bottom;}> .tippy-arrow:after{border-left-color:var(--dentsu-color-fuchsia);border-width:7px 0 7px 7px;right:-8px;bottom:-7px;}}&.nested{border:none;}.tippy-content{position:relative;z-index:1;}"]);
export var StyledMenuDivider = styled(Divider).attrs({
  isFlexChild: true
}).withConfig({
  displayName: "Menustyles__StyledMenuDivider",
  componentId: "sc-1e9kz8s-1"
})(["margin-left:24px;margin-right:24px;"]);
export var StyledMenuIconButton = styled(IconButton).withConfig({
  displayName: "Menustyles__StyledMenuIconButton",
  componentId: "sc-1e9kz8s-2"
})([""]);
export var StyledMenuButton = styled(Button).withConfig({
  displayName: "Menustyles__StyledMenuButton",
  componentId: "sc-1e9kz8s-3"
})([""]);
export var StyledMenuList = styled.div.withConfig({
  displayName: "Menustyles__StyledMenuList",
  componentId: "sc-1e9kz8s-4"
})(["min-width:160px;padding:16px 0;width:100%;position:relative;"]);
export var StyledMenuIcon = styled(Icon).attrs({
  size: 14,
  color: 'var(--dentsu-color-n650)'
}).withConfig({
  displayName: "Menustyles__StyledMenuIcon",
  componentId: "sc-1e9kz8s-5"
})(["margin-right:20px;"]);
export var StyledMenuIconChevron = styled(Icon).attrs({
  size: 14,
  color: 'var(--dentsu-color-n650)',
  icon: 'chevron-right'
}).withConfig({
  displayName: "Menustyles__StyledMenuIconChevron",
  componentId: "sc-1e9kz8s-6"
})(["margin-left:12px;"]);
export var StyledMenuExtra = styled.div.withConfig({
  displayName: "Menustyles__StyledMenuExtra",
  componentId: "sc-1e9kz8s-7"
})(["text-align:right;"]);
export var StyledMenuItem = styled.div.withConfig({
  displayName: "Menustyles__StyledMenuItem",
  componentId: "sc-1e9kz8s-8"
})(["padding:0 24px;height:32px;display:flex;align-items:center;font-size:var(--dentsu-font-size-14);line-height:var(--dentsu-font-size-16);color:var(--dentsu-color-black);cursor:pointer;outline:none;user-select:none;&:hover,&:focus,&[aria-expanded='true']{background:var(--dentsu-color-n100);}", ""], function (props) {
  return props.isDisabled && css(["pointer-events:none;color:var(--dentsu-color-black);cursor:not-allowed;& *{opacity:var(--dentsu-opacity-40);}"]);
});
export var StyledMenuLabel = styled.span.withConfig({
  displayName: "Menustyles__StyledMenuLabel",
  componentId: "sc-1e9kz8s-9"
})(["flex:1;"]);
export var StyledMenuGroup = styled.div.withConfig({
  displayName: "Menustyles__StyledMenuGroup",
  componentId: "sc-1e9kz8s-10"
})(["span.", "-menu__group--name{padding:16px 24px 8px;display:block;font-weight:var(--dentsu-font-weight-semibold);white-space:nowrap;text-transform:uppercase;color:var(--dentsu-color-n650);line-height:1;font-size:var(--dentsu-font-size-11);}"], prefix);
export var StyledMenuChip = styled(Chip).attrs({
  variant: 'status',
  status: 'neutral'
}).withConfig({
  displayName: "Menustyles__StyledMenuChip",
  componentId: "sc-1e9kz8s-11"
})(["transform:translateX(8px);"]);